import React from 'react';
import './Button.css'; // We will create this next

const Button = ({ variant = 'primary', children, onClick, disabled, type = 'button', ...props }) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
